import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { buildSignupTrackingProperties, clearSignupTrackingRef } from '../utils/analytics';

function PostHogPageView() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (location.hash) {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    if (location.pathname !== '/signup') {
      clearSignupTrackingRef();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!posthog) {
      return;
    }

    if (location.pathname === '/glp1-bridge') {
      return;
    }

    const signupProperties = location.pathname === '/signup'
      ? buildSignupTrackingProperties(location.search, location.state)
      : {};

    posthog.capture('$pageview', {
      $current_url: window.location.href,
      ...signupProperties,
    });
  }, [location.pathname, location.search, location.hash, location.state, posthog]);

  return null;
}

export default PostHogPageView;
